import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {MachineSentryActionDto} from '../../../types'
import {EditMachineSentryAction} from '../../../types/machine-sentry-actions.types'
import {TasksQueryKey} from '../useTasks'

import {MachineSentryActionQueryKey} from './useMachineSentryAction'

export const useUpdateMachineSentryAction = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<MachineSentryActionDto, AxiosError, EditMachineSentryAction>({
    mutationFn: async (data) => {
      const {id, plantUpmId} = data
      const path = `${TasksApiPath.MACHINE_SENTRY_ACTIONS}/${plantUpmId}/machine-sentry-actions/${id}`

      const payload = data

      const {data: response} = await ApiClient.axiosInstance.patch<MachineSentryActionDto>(
        path,
        payload
      )
      return response
    },
    onError: () => {
      spawnErrorToast(t('machineSentryActions.message.failedToUpdateMachineSentryAction'))
    },
    onSuccess: async () => {
      spawnSuccessToast(t('machineSentryActions.message.machineSentryActionUpdated'))
      await queryClient.invalidateQueries({
        queryKey: [MachineSentryActionQueryKey],
        refetchType: 'all'
      })
      await queryClient.invalidateQueries({queryKey: [TasksQueryKey], refetchType: 'all'})
      await queryClient.refetchQueries({queryKey: [TasksQueryKey]})
    }
  })
}
